import { useSyncExternalStore } from 'react';
import { useSettingsStore } from '../stores/useSettingsStore';

const LIGHT_QUERY = '(prefers-color-scheme: light)';

const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(LIGHT_QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const systemPrefersLight = () => window.matchMedia(LIGHT_QUERY).matches;

/**
 * True when the site is showing its dark theme. The site rule: 'system' is
 * dark unless the OS explicitly prefers light. Re-renders on OS changes.
 */
export const useIsDarkTheme = (): boolean => {
  const theme = useSettingsStore((state) => state.settings.theme);
  const prefersLight = useSyncExternalStore(subscribe, systemPrefersLight, () => false);
  return theme !== 'light' && !(theme === 'system' && prefersLight);
};
